const ConnectionType = {
    none: 0,
    wifi: 1,
    wired: 2,
} as const;

const OperationMode = {
    none: 0,
    gpu: 1,
    hybrid: 2,
    conventional: 3,
} as const;

const Power = {
    off: 0,
    on: 1,
} as const;

const Internet = {
    off: 0,
    on: 1,
} as const;

const MachineConfigType = {
    request: 0,
    acknowledgement: 1,
    failure: 2,
} as const;

const MachineConnectivityStatus = {
    disconnected: 0,
    connected: 1,
} as const;

type ConnectionValuesType = (typeof ConnectionType)[keyof typeof ConnectionType];
type OperationModeValuesType = (typeof OperationMode)[keyof typeof OperationMode];
type PowerType = (typeof Power)[keyof typeof Power];
type InternetType = (typeof Internet)[keyof typeof Internet];
type MachineConfigValuesType = (typeof MachineConfigType)[keyof typeof MachineConfigType];

export {
    ConnectionType,
    ConnectionValuesType,
    Internet,
    InternetType,
    MachineConfigType,
    MachineConfigValuesType,
    MachineConnectivityStatus,
    OperationMode,
    OperationModeValuesType,
    Power,
    PowerType,
};
